import { CommonModule } from '@angular/common';
import { Component, input, Input } from '@angular/core';

@Component({
  selector: 'app-no-data',
  standalone: true,
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
  host: {
    '[class.no-data__absolute]': 'isAbsolutePosition()',
  },
  imports: [CommonModule],
})
export class NoDataComponent {
  @Input() public inDialog = false;
  @Input() public tableNotFoundText = 'No results found';
  @Input() public tableNotFoundIcon = 'assets/images/common/no-results-found.svg';
  public isAbsolutePosition = input(true);
}
